import { useState } from "react";
import { useNavigate } from "react-router-dom";

    const Login = () => {
        const [email, setEmail] = useState("");
        const navigate = useNavigate();

        const handleChange = (e) => {
            setEmail(e.target.value);
        };

        const submitLogin = async (e) => {
            e.preventDefault();

        const res = await fetch("https://ankit1.jaskart.com/api/user/register", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email })
        });

        const data = await res.json();
        console.log(data);
                    
        if (data.success) {
            // ⭐ Save email for OTP verification page
            localStorage.setItem("email", email);

            // ⭐ Redirect user to OTP page
            navigate("/submit-otp");
        }
    };

    return (
        <>
            <div className="container-fluid p-0"  style={{
                            height: "100vh",
                            background: "black",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}>
                <div className="container">
                    <div 
                        style={{
                            height: "100vh",
                            background: "black",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                    >
                        <div>
                            <form
                                className="p-3 rounded"
                                style={{
                                    boxShadow: "6px 6px gray",
                                    background: "white"
                                }}
                                onSubmit={submitLogin}   // form submit handled here
                            >
                                <h1
                                    className="text-center"
                                    style={{ fontWeight: "700" }}
                                >
                                    Login
                                </h1>

                                <div className="row">
                                    <div className="col-md-12 pt-3">
                                        <label 
                                            htmlFor="exampleFormControlInput1" 
                                            className="form-label"
                                        >
                                            Email
                                        </label>

                                        <input
                                            type="email"
                                            className="form-control p-2 w-100"
                                            id="exampleFormControlInput1"
                                            value={email}
                                            onChange={handleChange}   // FIXED
                                            placeholder="Email@email.com"
                                            required
                                        />
                                    </div>

                                    <div className="col-md-12 pt-3 text-center pb-3">
                                        <button
                                            className="btn w-100"
                                            style={{
                                                boxShadow: "6px 6px gray",
                                                background: "black",
                                                color: "white"
                                            }}
                                            type="submit"    // FIXED
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Login;
